export const APP_VERSION_HEADER = 'x-worldcoo-app-version';
export const APP_VERSION_STORAGE_KEY = 'worldcoo:app-version';

export function syncVersionFromHeader(response: Response) {
	if (typeof window === 'undefined') return;

	const version = response.headers.get(APP_VERSION_HEADER);
	if (!version) return;

	try {
		if (window.localStorage.getItem(APP_VERSION_STORAGE_KEY) !== version) {
			window.localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
		}
	} catch {
		// Storage unavailable — the version simply stays unknown.
	}
}
